export const css = {
    oneaction: 'fnus9j8Y',
    ' _key': 'certwise-theme/certwise/quiz-widgets/discussion'
};
export default css;
